import { render } from "./CookiesView.vue?vue&type=template&id=90d352da"
import script from "./CookiesView.vue?vue&type=script&lang=js"
export * from "./CookiesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__